import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import './LanguageSwitcher.css';

const LanguageSwitcher = ({ onLanguageChange }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const isEnglish = location.pathname.startsWith('/en');
  
  const switchLanguage = (lang) => {
    let newPath = location.pathname;
    
    // Path mapping for Turkish to English and vice versa
    const trToEnMap = {
      '/': '/en',
      '/hakkinda': '/en/about',
      '/projeler': '/en/projects',
      '/iletisim': '/en/contact',
      '/duyurular': '/en/announcements',
      '/uygulamalar': '/en/applications',
      '/destek': '/en/support',
      '/progenxakademi': '/en/academy',
      '/cerez-politikasi': '/en/cookie-policy'
    };
    
    const enToTrMap = {
      '/en': '/',
      '/en/about': '/hakkinda',
      '/en/projects': '/projeler',
      '/en/contact': '/iletisim',
      '/en/announcements': '/duyurular',
      '/en/applications': '/uygulamalar',
      '/en/support': '/destek',
      '/en/academy': '/progenxakademi',
      '/en/cookie-policy': '/cerez-politikasi'
    };
    
    if (lang === 'en') {
      // Turkish to English
      if (!newPath.startsWith('/en')) {
        // Check if there's a direct mapping
        if (trToEnMap[newPath]) {
          newPath = trToEnMap[newPath];
        } else {
          // Handle dynamic routes (e.g., /duyurular/:slug)
          const pathParts = newPath.split('/');
          if (pathParts.length > 1) {
            const basePath = '/' + pathParts[1];
            if (trToEnMap[basePath]) {
              newPath = trToEnMap[basePath] + (pathParts.length > 2 ? '/' + pathParts.slice(2).join('/') : '');
            } else {
              newPath = '/en' + newPath;
            }
          } else {
            newPath = '/en';
          }
        }
      }
    } else {
      // English to Turkish
      if (newPath.startsWith('/en')) {
        // Check if there's a direct mapping
        if (enToTrMap[newPath]) {
          newPath = enToTrMap[newPath];
        } else {
          // Handle dynamic routes (e.g., /en/announcements/:slug)
          const pathParts = newPath.replace('/en', '').split('/');
          if (pathParts.length > 1 && pathParts[0] === '') {
            const basePath = '/en/' + pathParts[1];
            if (enToTrMap[basePath]) {
              newPath = enToTrMap[basePath] + (pathParts.length > 2 ? '/' + pathParts.slice(2).join('/') : '');
            } else {
              newPath = newPath.replace(/^\/en/, '');
              if (newPath === '') {
                newPath = '/';
              }
            }
          } else {
            newPath = newPath.replace(/^\/en/, '');
            if (newPath === '') {
              newPath = '/';
            }
          }
        }
      }
    }
    
    navigate(newPath);
    
    // Close mobile menu if callback is provided
    if (onLanguageChange) {
      onLanguageChange();
    }
  };

  return (
    <div className="language-switcher">
      <button 
        className={`lang-btn ${!isEnglish ? 'active' : ''}`}
        onClick={() => switchLanguage('tr')}
        aria-label="Türkçe"
      >
        TR
      </button>
      <button 
        className={`lang-btn ${isEnglish ? 'active' : ''}`}
        onClick={() => switchLanguage('en')}
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
